(function() {
  var VideoConsent = {
    openLighbox : null,
    initialize: function () {
      var videoPlayerLinks = document.getElementsByClassName('js-privacy-consent');

      if (videoPlayerLinks.length > 0) {
        for (var i = 0; i < videoPlayerLinks.length; i++) {
          videoPlayerLinks[i].addEventListener('click', VideoConsent.handleConsent);
        }
      }
    },
    handleConsent: function(e) {
      e.preventDefault();

      var currentLink = e.target.closest('a');
      var embedUrl = currentLink.getAttribute('data-embed-url');
      var consentElement = currentLink.getAttribute('data-consent-content');

      if (VideoConsent.getCookie('youtube-consent')) {
        VideoConsent.embed(currentLink, embedUrl);
      } else {
        VideoConsent.openLighbox = new bootstrap.Modal(document.getElementById(consentElement), {});

        VideoConsent.openLighbox.show();

        var denyButton = document.querySelector('.js-video-consent-deny');
        denyButton.addEventListener('click', VideoConsent.denyEmbedding);

        var allowButton = document.querySelector('.js-video-consent-allow');
        allowButton.addEventListener('click', function(e) {
          e.preventDefault();
          VideoConsent.allowEmbedding(currentLink, embedUrl);
        });
      }
    },
    denyEmbedding: function(e) {
      e.preventDefault();
      VideoConsent.openLighbox.hide();
    },
    allowEmbedding: function(currentLink, embedUrl) {
      var allVideos = document.querySelector('.js-video-consent-all-videos');

      if (typeof allVideos !== 'undefined' && allVideos.checked) {
        var date = new Date();
        date.setTime(+ date + (365 * (24*60*60*1000)));
        expirationDate = "; expires=" + date.toUTCString();
        document.cookie = "youtube-consent=1" + expirationDate + "; path=/";
      }

      VideoConsent.embed(currentLink, embedUrl);
      VideoConsent.openLighbox.hide();
    },
    embed: function(elementToReplace, embedUrl) {
      if (elementToReplace) {
        elementToReplace.outerHTML = '<iframe width="' + elementToReplace.offsetWidth + '" height="' + elementToReplace.offsetHeight + '" src="' + embedUrl + '" onload="this.contentWindow.focus();" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
      }
    },
    getCookie: function (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    }
  };

  VideoConsent.initialize();
})();
